import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';
import { AuthCard } from '../../components/AuthLayout';
import { useApi } from '../../auth/AuthProvider';
import { useTranslation } from '../../i18n/I18nProvider';
import { toErrorMessage } from '../../i18n/errorMessage';
import { Button, Input } from '../../ui';

export function ForgotPassword() {
  const { t } = useTranslation();
  const api = useApi();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.auth.forgot({ email });
      setSent(true);
    } catch (err) {
      setError(toErrorMessage(t, err).title);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthCard
      title={t('auth.forgotTitle')}
      subtitle={t('auth.forgotSubtitle')}
      footer={
        <Link to="/prijava" className="text-accent-dark underline">
          {t('auth.backToLogin')}
        </Link>
      }
    >
      {sent ? (
        <p role="status" className="text-[14.5px] leading-relaxed text-ink">
          {t('auth.forgotSent')}
        </p>
      ) : (
        <form onSubmit={onSubmit} className="flex flex-col gap-4" noValidate>
          <Input
            id="forgot-email"
            type="email"
            label={t('auth.email')}
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && (
            <p role="alert" className="text-[13px] text-danger">
              {error}
            </p>
          )}
          <Button type="submit" block loading={busy}>
            {t('auth.forgotSubmit')}
          </Button>
        </form>
      )}
    </AuthCard>
  );
}
